import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import '@businesscomponents29/prietoelements/src/media/css/neoTypography.css';
import '@businesscomponents29/prietoelements/src/media/css/neoElements.css';
import '@businesscomponents29/prietoelements/src/media/css/effects.css';
import '@businesscomponents29/prietoelements/src/media/css/effects.scss';
import '@businesscomponents29/prietoelements/src/media/css/neoTypography.css';
import '@businesscomponents29/prietoelements/src/media/css/neoElements.css';
import '@businesscomponents29/prietoelements/src/media/css/effects.css';
import App from '@businesscomponents29/prietoelements/dist/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
